'use client'

import { ThemeProvider } from 'next-themes'

export function SwitchThemeProvider({ children }) {
  return <ThemeProvider attribute="class">{children}</ThemeProvider>
}
